import React from 'react';
import { Star } from 'lucide-react';

const TestimonialCard = ({ photo, name, position, company, testimonial, rating = 5 }) => {
  return (
    <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className="flex items-center mb-4">
        <div className="w-14 h-14 rounded-full bg-aug-blue-light overflow-hidden mr-4">
          {photo ? (
            <img src={photo} alt={name} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-aug-blue font-bold text-xl">
              {name.charAt(0)}
            </div>
          )}
        </div>
        <div>
          <h4 className="font-semibold text-aug-gray-dark">{name}</h4>
          <p className="text-sm text-aug-gray-medium">{position}</p>
          <p className="text-sm text-aug-blue">{company}</p>
        </div>
      </div>
      
      <p className="text-aug-gray-medium italic mb-4 leading-relaxed">
        "{testimonial}"
      </p>
      
      <div className="flex space-x-1">
        {[...Array(rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-aug-warning text-aug-warning" />
        ))}
      </div>
    </div>
  );
};

export default TestimonialCard;